import { useEffect, useState, useRef } from "react";
import CustomButton from "../../components/CustomButton";
import { LuArrowDownUp } from "react-icons/lu";
import { RiBarChartHorizontalLine } from "react-icons/ri";
import GameCard from "../../components/GameCard";
import "../../assets/css/GameList.css";
import GameSorting from "../../components/GameSorting";
import FilterPage from "../filterpage/FIlterPage";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import GoogleMapComponent from "../../components/GoogleMap";
import { useLocation } from "react-router-dom";
import PaymentModal from "../../components/PaymentModal";
import { RxCross2 } from "react-icons/rx";
import CustomPagination from '../../components/CustomPagination';
import { saveCourtData, saveFilterUpdating, saveUserData } from "../../redux/UserDataSlice";
import { HashLoader } from 'react-spinners';
import Nav from 'react-bootstrap/Nav';
import { HiOutlineViewList } from "react-icons/hi";
import { FaMapLocation } from "react-icons/fa6";
import { saveCardDetail, saveSubscriptionPlan, saveConfiguration, saveProfileData, saveSportDetailConfig, saveFetchMinorPermission, saveMinorAccountList } from "../../redux/UserDataSlice";
import { useGameSocket } from "./GameSocketListener.js";
import { MdFilterList } from "react-icons/md";
import SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";
import Modal from "react-modal";
import { motion } from "framer-motion";

const GameList = () => {

    const [isSearchMap, setIsSearchMap] = useState(false);
    const [showSortSection, setShowSortSection] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [games, setGames] = useState([]);
    const { accessToken, saveCardDetailData, userAuthId } = useSelector((state) => state.loginInfo);
    const [joinedGames, setJoinedGames] = useState([]);
    const [showSpinner, setShowSpinner] = useState(true);
    const [courtData, setCourtData] = useState();
    const [formData, setFormData] = useState();
    const [errors, setErrors] = useState({});
    const location = useLocation();
    const mapView = location.state?.mapView;
    const [isOpen, setIsOpen] = useState(false);
    const [selectedGameId, setSelectedGameId] = useState();
    const [clearFilter, setClearFilter] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const { profilefilterUpdate } = useSelector((state) => state?.loginInfo);
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('show-list');
    const sortRef = useRef(null);
    const { userId, filterUpdating } = useSelector((state) => state.loginInfo);
    // const { socketGame } = useGameSocket();
    const modalRef = useRef(null);

    const toggleSortSection = () => {
        setActiveTab('show-list');
        setShowSortSection((prev) => !prev);
        setShowFilterModal(false);

    };

    const toggleFilterModal = () => {
        setShowFilterModal(true);
        setShowSortSection(false);
        setShowMapModal(false);
    };

    const toggleMapModal = (e) => {
        const isChecked = e;
        setIsSearchMap(isChecked);
        if (isChecked) {
            setShowMapModal(true);
        } else {
            setShowMapModal(false);
        }
        setShowFilterModal(false);
    };

    const onCancel = () => {
        setShowFilterModal(false);
    };

    const onApplyFilter = () => {
        setShowFilterModal(false);
    };

    const onRequestJoined = async (gameId) => {
        setSelectedGameId(gameId);
        if (saveCardDetailData?.userConfgis?.isEligibleForService) {
            const payload = {
                gameId: gameId,
                paymentIntentId: null,
                transactionId: null
            }
            try {
                const result = await apiHandler({
                    url: `${endpoint.GAME_REQUESTED_TO_JOIN}`,
                    method: "POST",
                    data: payload,
                    authToken: accessToken?.accessToken,
                });

                if (result?.data?.code !== '500' && !(result?.data?.user_description == 'An unexpected error occurred')) {
                    setJoinedGames((prev) => [...prev, gameId]);
                    toast.success("Successfully joined the game!");
                } else {
                    toast.error("Failed to join the game.");
                }
            } catch (error) {
                toast.error("Failed to join the game.");
            }
        } else {
            setIsOpen(true);
        }
    };

    const onLeaveButton = (gameId, gamestatus, isRequested, isWaitingPlayer, requiredPlayers, currentPlayers) => (
        <div>
            <CustomButton
                buttonText={isRequested !== true && isWaitingPlayer !== true ? "Request to Join" : 'Waiting List'}
                id="request-to-join"
                className={`${isRequested !== true &&
                    isWaitingPlayer !== true
                    ? "request-join-game-btn"
                    : "request-join-game-btn-disable"
                    }`}
                onClick={() => {
                    onRequestJoined(gameId);
                    return false;
                }}
                disabled={!(isRequested !== true && isWaitingPlayer !== true) || (requiredPlayers - currentPlayers == 0)}
            />
        </div>
    );

    const onGameList = async (gameId) => {
        await apiHandler({
            url: `${endpoint.GAME_DETAIL}?gameId=${gameId}`,
            method: "GET",
            authToken: accessToken?.accessToken,
        });
    };

    const onSort = async (data) => {
        const distance = data === "earliestToLatest" ? "distance" : data === "latestToEarliest" ? "start_time" : "";
        const direction = data === "distanceFarToNear" ? "desc" : data === "distanceNearToFar" ? "asc" : "";

        try {
            setShowSpinner(true);
            const result = await apiHandler({
                url: `${endpoint.FETCH_EXPLORE_DATA}?sortBy=${distance}&direction=${direction}`,
                method: "GET",
                authToken: accessToken?.accessToken,
            });

            if (result?.data.code !== 500) {
                setGames(result.data.content);
            } else {
                toast.error("Something went wrong");
            }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setShowSpinner(false);
        }
    };

    const fetchGames = async () => {
        try {
            setShowSpinner(true);
            const result = await apiHandler({
                url: endpoint.FETCH_EXPLORE_DATA,
                method: "GET",
                authToken: accessToken?.accessToken,
            });

            if (result?.data.code !== 500) {
                setGames(result?.data);
                setGames(result.data.content);
                setTotalPages(result.data.totalPages);
                setCurrentPage(result.data.currentPage + 1);
            } else {
                toast.error("Something went wrong");
            }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setShowSpinner(false);
        }
    };

    useEffect(() => {
        fetchGames();
    }, [joinedGames, clearFilter, profilefilterUpdate]);
    // socketGame

    useEffect(() => {
        const fetchCourt = async () => {
            setShowSpinner(true);
            try {
                const result = await apiHandler({
                    url: endpoint.FETCH_MAP_COURT,
                    method: "GET",
                    authToken: accessToken?.accessToken,
                });
                if (!result?.data?.error) {
                    setCourtData(result?.data?.courts);
                    dispatch(saveCourtData(result?.data?.courts));
                } else {
                    toast.error("Something went wrong");
                }
            } catch (error) {
                console.error("Error fetching court data:", error);
            }
            setShowSpinner(false);
        };
        fetchCourt();
    }, []);

    useEffect(() => {
        setIsSearchMap(mapView);
        if (mapView) setShowMapModal(true);
    }, [mapView]);

    useEffect(() => {
        if (activeTab === 'show-map') {
            toggleMapModal(true);
        } else {
            toggleMapModal(false);
        }
    }, [activeTab]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (sortRef.current && !sortRef.current.contains(event.target)) {
                setShowSortSection(false);
            }
        }

        if (showSortSection) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showSortSection]);


    const handleCourtSelectFromMap = (court) => {
        setFormData((prev) => ({
            ...prev,
            courtName: court.courtName,
        }));

        if (errors.courtName) {
            setErrors({
                ...errors,
                courtName: "",
            });
        }
    };

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };

    const onClearFilter = (status) => {
        setClearFilter(status);
        setShowFilterModal(false);
    };
    const onMapView = () => {
        setShowMapModal(false);
        setIsSearchMap(false);
        setActiveTab('show-list')
    }

    const handlePageChange = (page) => {
        fetchGames(page);
    };

    const onShowMapModal = () => {
        setShowMapModal(false);
        setIsSearchMap(false);
        setActiveTab('show-list')
    }

    const SaveCardDetailAPI = async () => {
        try {
            const result = await apiHandler({
                url: endpoint.SAVE_CARD_DETAIL_API,
                method: "GET",
                authToken: accessToken.accessToken
            });
            dispatch(saveCardDetail(result?.data));
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || "An unexpected error occurred.");
        }
    };

    const subscriptionPlan = async () => {
        try {
            const result = await apiHandler({
                url: endpoint.SUBSCRIPTION_PLAN,
                method: "GET",
                authToken: accessToken?.accessToken
            });

            const fetchedPlans = result?.data || [];
            dispatch(saveSubscriptionPlan(fetchedPlans));
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || "An unexpected error occurred.");
        }
    };

    const fetchConfiguration = async () => {
        try {
            const result = await apiHandler({
                url: endpoint.FETCH_DETAIL_FOR_OT_API,
                method: "GET",
                authToken: accessToken?.accessToken
            });
            const fetchedDetail = result?.data || [];
            dispatch(saveConfiguration(fetchedDetail));
        } catch (error) {
            toast.error(error.response?.data?.message || error.message || "An unexpected error occurred.");
        }
    };

    const fetchProfileData = async () => {
        try {
            const result = await apiHandler({
                url: `${endpoint.PLAYER_PROFILE}?id=${userId}`,
                method: "GET",
                authToken: accessToken?.accessToken,
            });
            dispatch(saveUserData(result?.baseProfile))
            dispatch(saveProfileData(result?.data));
        } catch (error) {
            console.error("Error fetching profile data:", error);
        }
    };
    const fetchSportDetailConfig = async () => {
        try {
            const result = await apiHandler({
                url: `${endpoint.FECH_SPORTS_DETAIL_CONFIG}`,
                method: "GET",
                authToken: accessToken?.accessToken,
            });
            dispatch(saveSportDetailConfig(result?.data?.sports));
        } catch (error) {
            console.error("Error fetching profile data:", error);
        }
    };

    const fetchPermissionData = async () => {
        try {
            const result = await apiHandler({
                url: `${endpoint.FETCH_MINOR_PERMISSION}`,
                method: "GET",
                authToken: accessToken?.accessToken,
            });
            dispatch(saveFetchMinorPermission(result?.data));
        } catch (error) {
            console.error("Error fetching profile data:", error);
        }
    };

    const fetchMinorAccountList = async () => {
        try {
            const result = await apiHandler({
                url: `${endpoint.MINOR_ACCOUNT_LIST}`,
                method: "GET",
                authToken: accessToken?.accessToken,
            });
            dispatch(saveMinorAccountList(result.data || []));
        } catch (error) {
            console.error("Error fetching account list:", error);
        }
    };

    useEffect(() => {
        subscriptionPlan();
        SaveCardDetailAPI();
        fetchConfiguration();
        fetchProfileData();
        fetchSportDetailConfig();
        fetchPermissionData();
        fetchMinorAccountList();
        dispatch(saveFilterUpdating(!filterUpdating))
    }, []);

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setShowFilterModal(false)
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className="container mt-sm-3 p-3 p-sm-0" >
                <div className="p-sm-2 d-sm-flex justify-content-between " style={{ borderRadius: "10px" }}>
                    <div className="">
                        <Nav
                            activeKey={activeTab}
                            onSelect={(selectedKey) => setActiveTab(selectedKey)}
                            className="d-flex w-100 custom-tab-nav"
                        >
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link eventKey="show-list" className="games-tab-text explore-txt"><HiOutlineViewList /> List View</Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link eventKey="show-map" className="games-tab-text explore-txt" ><FaMapLocation /> Map View</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <div className="d-flex justify-content-between mt-3 mt-sm-0">
                        <CustomButton
                            icon={<LuArrowDownUp />}
                            iconClass="pe-2"
                            buttonText={"Sort"}
                            className="game-list-sort-button px-4 py-2 py-sm-0 me-2"
                            onClick={toggleSortSection}
                        />

                        <CustomButton
                            icon={< MdFilterList style={{ fontSize: '20px' }} />}
                            iconClass="pe-2"
                            buttonText={"Filter"}
                            onClick={toggleFilterModal}
                            className="game-list-sort-button px-4 py-2"
                        />
                    </div>
                </div>
                {/* Filter Modal */}
                {showFilterModal && (
                    <div className="modal-overlay open">
                        <div ref={modalRef} className="modal-content overflow-x-auto">
                            <FilterPage
                                onCancel={onCancel}
                                onApplyFilter={onApplyFilter}
                                onClearFilter={onClearFilter}
                                clearFilter={clearFilter}
                            />
                        </div>
                    </div>
                )}
                {showSpinner && (
                    <div className="d-flex align-items-center justify-content-center">
                        <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
                            <HashLoader color="#e48181" />
                        </div>
                    </div>
                )}

                {!showSpinner && activeTab === 'show-map' && (
                    courtData?.length > 0 ? (
                        <div className="modal-overlay open">
                            <div className="modal-content map-modal-wrapper">
                                <button onClick={onMapView} className="close-button">
                                    <RxCross2 className="fs-4" />
                                </button>
                                <h4 className="mb-3">Map View</h4>
                                <GoogleMapComponent
                                    courtData={courtData}
                                    onCourtSelect={handleCourtSelectFromMap}
                                    onShowMapModal={onShowMapModal}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="d-flex align-items-center justify-content-center" style={{ height: '59vh' }}>
                            <h2 className="text-center mt-3 fs-2" style={{ fontWeight: '600', color: 'rgba(33, 37, 41, 0.75)' }}>
                                No Games Found In Your Location
                            </h2>
                        </div>
                    )
                )}

                {!showMapModal &&
                    <div className="row">
                        <div className="col-lg-12">
                            <div>
                                {showSortSection && (
                                    <div ref={sortRef}>
                                        <GameSorting onSort={(sortType) => {
                                            onSort(sortType)
                                            setShowSortSection(false)
                                        }} />
                                    </div>
                                )}
                            </div>

                            {!showSpinner ? (
                                <div className="pt-2 pt-sm-4 h-100">
                                    {games?.length > 0 ? (
                                        <div className="row" style={{ rowGap: '10px' }}>
                                            {console.log('games', games)}
                                            {games?.map((game) => (
                                                <div key={game?.id} className="col-lg-6 col-sm-12 col-md-12 mb-0 mb-sm-4">
                                                    <GameCard
                                                        LeaveButton={onLeaveButton(game?.gameId, game?.status, game.isRequested, game.isWaitingPlayer, game?.requiredPlayers, game?.currentPlayers)}
                                                        gameData={game}
                                                        NotShowchat={true}

                                                        onClick={() => onGameList(game?.gameId)}
                                                    />


                                                    {/* Payment Modal */}
                                                    {isOpen && (
                                                        <div className="modal-overlay open">
                                                            <div className="modal-content" style={{ width: "100%", height: "500px", overflow: 'auto' }}>
                                                                <button onClick={toggleModal} className="close-button">
                                                                    <RxCross2 className="fs-4" />
                                                                </button>
                                                                <PaymentModal PaymentWay={"joinedGame"} gameId={selectedGameId} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}

                                        </div>
                                    ) : (
                                        <div className="d-flex justify-content-center width-100 align-items-center" style={{ height: '50vh' }} >
                                            <h2 className="text-center mt-3 fs-2" style={{ fontWeight: '600', color: 'rgb(33 37 41 / 75%)' }}>No Games Found In Your Location</h2>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="d-flex align-items-center justify-content-center" >
                                    <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
                                        < HashLoader color="#e48181" />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                }
                {totalPages > 1 && (
                    <CustomPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}
            </div>
        </>
    );
};

export default GameList;
